var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forbidden"},[_c('v-img',{attrs:{"max-height":"550","max-width":"1250","src":require("../assets/img/403.png")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }